export function useOrientation(): Ref<boolean> {
  return useMediaQuery('(orientation: landscape) and (pointer: coarse)')
}
